export const UPDATED_APPOINTMENT_STEP_DATA = "UPDATED_APPOINTMENT_STEP_DATA";
export const UPDATED_STATE_DATE_PICKER_APPOINTMENT =
  "UPDATED_STATE_DATE_PICKER_APPOINTMENT";
export const GOT_STAFF_SERVICES_AND_MORE = "GOT_STAFF_SERVICES_AND_MORE";
export const GET_STAFF_SERVICES_AND_MORE = "GET_STAFF_SERVICES_AND_MORE";
export const GET_CUSTOMERS_BASED_ON_FILTER = "GET_CUSTOMERS_BASED_ON_FILTER";
export const GOT_CUSTOMERS_BASED_ON_FILTER = "GOT_CUSTOMERS_BASED_ON_FILTER";
export const UPDATE_SERVICE_DROPDOWN_VISIBILITY =
  "UPDATE_SERVICE_DROPDOWN_VISIBILITY";
export const UPDATE_IS_SHOWING_ADDRESS_FORM = "UPDATE_IS_SHOWING_ADDRESS_FORM";
export const UPDATE_TEMP_ADDRESS_DATA = "UPDATE_TEMP_ADDRESS_DATA";
export const UPDATED_APPOINTMENT_STEP_START_DATE_TIME =
  "UPDATED_APPOINTMENT_STEP_START_DATE_TIME";
export const UPDATE_TEMP_BOOKING_ADDRESS = "UPDATE_TEMP_BOOKING_ADDRESS";

export const GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES =
  "GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES";
export const GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES =
  "GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES";
export const ERROR_GETTING_BOOKINGS_FOR_RESOURCE_WITHIN_DATES =
  "ERROR_GETTING_BOOKINGS_FOR_RESOURCE_WITHIN_DATES";

export const UPDATE_CUSTOMER_DROPDOWN_VISIBILITY =
  "UPDATE_CUSTOMER_DROPDOWN_VISIBILITY";

export const CLEAR_ADDRESS_FORM_IN_APPOINTMENT_STEP =
  "CLEAR_ADDRESS_FORM_IN_APPOINTMENT_STEP";

export const GET_PROFILE_FOR_CURRENT_USER = "GET_PROFILE_FOR_CURRENT_USER";
export const GOT_PROFILE_FOR_CURRENT_USER = "GOT_PROFILE_FOR_CURRENT_USER";

export const MOVE_APPOINTMENT_TRIGGERED = "MOVE_APPOINTMENT_TRIGGERED";

export const UPDATE_CURRENTLY_LOGGED_IN_STAFF =
  "UPDATE_CURRENTLY_LOGGED_IN_STAFF";

export function updateCurrentlyLoggedInStaff(staffId) {
  return {
    type: UPDATE_CURRENTLY_LOGGED_IN_STAFF,
    data: staffId
  };
}

export function getProfileForCurrentUser() {
  return {
    type: GET_PROFILE_FOR_CURRENT_USER
  };
}

export function moveAppointmentTriggered(date, time) {
  return {
    type: MOVE_APPOINTMENT_TRIGGERED,
    data: {
      date,
      time
    }
  };
}

export function loadCachedProfileForCurrentUser(cachedData) {
  return {
    type: GOT_PROFILE_FOR_CURRENT_USER,
    data: cachedData
  };
}

export const getBookingsForResourceWithinDates = (
  resourceId,
  startDate,
  endDate,
  bookingId,
  cb,
  item
) => {
  return {
    type: GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
    data: {
      resourceId,
      startDate,
      endDate,
      bookingId,
      cb,
      item
    }
  };
};
export function updateAppointmentStepData(stepData) {
  return {
    type: UPDATED_APPOINTMENT_STEP_DATA,
    data: stepData
  };
}

export function updateAppointmentStepStartDateTime(
  date,
  time,
  selectedStaffId,
  selectedServiceId,
  selectedLocationId
) {
  return {
    type: UPDATED_APPOINTMENT_STEP_START_DATE_TIME,
    data: { date, time, selectedStaffId, selectedServiceId, selectedLocationId }
  };
}

export function updateStateDatePickerAppointment(open) {
  return {
    type: UPDATED_STATE_DATE_PICKER_APPOINTMENT,
    data: open
  };
}

export function updateCustomerDropdownVisibility(open) {
  return {
    type: UPDATE_CUSTOMER_DROPDOWN_VISIBILITY,
    data: open
  };
}

export const getStaffServicesAndMore = () => {
  return {
    type: GET_STAFF_SERVICES_AND_MORE
  };
};

export const getCustomersBasedOnFilter = filter => {
  return {
    type: GET_CUSTOMERS_BASED_ON_FILTER,
    filter
  };
};

export const updateServiceDropdownVisibility = visible => {
  return {
    type: UPDATE_SERVICE_DROPDOWN_VISIBILITY,
    data: visible
  };
};

export const updateIsShowingAddressForm = shown => {
  return {
    type: UPDATE_IS_SHOWING_ADDRESS_FORM,
    isShowing: shown
  };
};

export const updatetemporaryBookingAddress = addressData => {
  return {
    type: UPDATE_TEMP_BOOKING_ADDRESS,
    data: addressData
  };
};

export const clearAddressFormInAppointmentStep = () => {
  return {
    type: CLEAR_ADDRESS_FORM_IN_APPOINTMENT_STEP
  };
};

export const loadCachedProviderDetails = cachedData => {
  return {
    type: GOT_STAFF_SERVICES_AND_MORE,
    data: cachedData
  };
};
